<template>
  <v-card class="step-card">
    <h3>{{ $t(`registration.secondStep.title`) }}</h3>

    <v-text-field
      v-mask="'+7(###) ###-##-##'"
      v-model="$v.form.phone.$model"
      :label="$t(`registration.secondStep.numberLabel`)"
      outlined
      rounded
      :error="$v.form.phone.$error"
      @blur="$v.form.phone.$touch()"
    ></v-text-field>

    <v-text-field
      v-model="$v.form.additionalPhone.$model"
      v-mask="'+7(###) ###-##-##'"
      :label="$t(`registration.secondStep.additionalNumberLabel`)"
      outlined
      rounded
      :error="$v.form.additionalPhone.$error"
      @blur="$v.form.additionalPhone.$touch()"
    ></v-text-field>

    <v-text-field
      v-model="$v.form.email.$model"
      :label="$t(`registration.secondStep.emailLabel`)"
      outlined
      type="email"
      rounded
      :error="$v.form.email.$error"
      @blur="$v.form.email.$touch()"
    ></v-text-field>

    <v-text-field
      v-model="$v.form.workplace.$model"
      :label="$t(`registration.secondStep.workplace`)"
      outlined
      rounded
      :error="$v.form.workplace.$error"
      @blur="$v.form.workplace.$touch()"
    ></v-text-field>

    <v-checkbox
      v-model="agreement"
      :label="$t(`registration.secondStep.processingData`)"
      :error="!agreement && touched"
      @change="touched = true"
    ></v-checkbox>

    <NextButton
      @click="handleNextStep"
      :text="$t(`registration.secondStep.nextBtn`)"
    />
  </v-card>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email, helpers } from "vuelidate/lib/validators";
import NextButton from "@/components/custom/NextButton.vue";
import { showToast } from "@/utils/toast";

const phoneMask = helpers.regex(
  "phoneMask",
  /^\+7\(\d{3}\)\s\d{3}-\d{2}-\d{2}$/
);

export default {
  components: { NextButton },
  mixins: [validationMixin],

  data() {
    return {
      form: {
        phone: "",
        additionalPhone: "",
        email: "",
        workplace: "",
      },
      agreement: false,
      touched: false,
    };
  },

  validations: {
    form: {
      phone: {
        required,
        phoneMask,
      },
      additionalPhone: {
        phoneMask,
      },
      email: { required, email },
      workplace: { required },
    },
  },
  computed: {
    isFormValid() {
      return !this.$v.form.$invalid && this.agreement;
    },
  },
  methods: {
    handleNextStep() {
      this.$v.$touch();
      this.touched = true;

      if (!this.isFormValid) {
        showToast(this, {
          text: this.$t(`toastText.fields`),
          status: "warning",
          duration: 3000,
        });
        return;
      }

      if (this.isFormValid) {
        this.$emit("nextStep");
      }
    },
  },
};
</script>

<style scoped>
.step-card {
  padding: 20px;
  text-align: center;
  font-family: "Montserrat", sans-serif;
}
.step-card h3 {
  font-family: "Montserrat", sans-serif;
}
</style>
